/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown> }} Booking_Waitlist_SuccessInputs */

const en_booking_waitlist_success = /** @type {(inputs: Booking_Waitlist_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You are #${i?.position} on the waitlist! We'll email you if a spot opens.`)
};

const es_booking_waitlist_success = /** @type {(inputs: Booking_Waitlist_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¡Eres el #${i?.position} en la lista! Te enviaremos un correo si se abre un espacio.`)
};

const fr_booking_waitlist_success = /** @type {(inputs: Booking_Waitlist_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous êtes n°${i?.position} sur la liste d'attente ! Nous vous enverrons un e-mail si une place se libère.`)
};

const de_booking_waitlist_success = /** @type {(inputs: Booking_Waitlist_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du bist auf Platz #${i?.position} der Warteliste! Wir senden dir eine E-Mail, wenn ein Platz frei wird.`)
};

const id_booking_waitlist_success = /** @type {(inputs: Booking_Waitlist_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anda berada di urutan #${i?.position} pada daftar tunggu! Kami akan mengirim email jika ada tempat kosong.`)
};

/** @type {(inputs: Booking_Waitlist_SuccessInputs) => LocalizedString} */
const ja_booking_waitlist_success = en_booking_waitlist_success;

/** @type {(inputs: Booking_Waitlist_SuccessInputs) => LocalizedString} */
const zh_booking_waitlist_success = en_booking_waitlist_success;

/** @type {(inputs: Booking_Waitlist_SuccessInputs) => LocalizedString} */
const ar_booking_waitlist_success = en_booking_waitlist_success;

/** @type {(inputs: Booking_Waitlist_SuccessInputs) => LocalizedString} */
const it_booking_waitlist_success = en_booking_waitlist_success;

/** @type {(inputs: Booking_Waitlist_SuccessInputs) => LocalizedString} */
const ru_booking_waitlist_success = en_booking_waitlist_success;

/** @type {(inputs: Booking_Waitlist_SuccessInputs) => LocalizedString} */
const pt_booking_waitlist_success = en_booking_waitlist_success;

/** @type {(inputs: Booking_Waitlist_SuccessInputs) => LocalizedString} */
const ko_booking_waitlist_success = en_booking_waitlist_success;

/**
* | output |
* | --- |
* | "You are #{position} on the waitlist! We'll email you if a spot opens." |
*
* @param {Booking_Waitlist_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_waitlist_success = /** @type {((inputs: Booking_Waitlist_SuccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Waitlist_SuccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_waitlist_success(inputs)
	if (locale === "es") return es_booking_waitlist_success(inputs)
	if (locale === "fr") return fr_booking_waitlist_success(inputs)
	if (locale === "de") return de_booking_waitlist_success(inputs)
	if (locale === "ja") return ja_booking_waitlist_success(inputs)
	if (locale === "zh") return zh_booking_waitlist_success(inputs)
	if (locale === "ar") return ar_booking_waitlist_success(inputs)
	if (locale === "id") return id_booking_waitlist_success(inputs)
	if (locale === "it") return it_booking_waitlist_success(inputs)
	if (locale === "ru") return ru_booking_waitlist_success(inputs)
	if (locale === "pt") return pt_booking_waitlist_success(inputs)
	return ko_booking_waitlist_success(inputs)
});